<div [formGroup]="group">
  <mat-form-field appearance="outline" class="field-autocomplete">
    <mat-label>{{ config.label }}</mat-label>
    <input #field type="text" matInput (keyup)="onKeyup($event)" [formControlName]="config.name"
      [matAutocomplete]="fieldAutocomplete"
      (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
      (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), field)"
      >
    <mat-autocomplete #fieldAutocomplete [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredResults" [value]="option">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
    <!-- <mat-error *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
      <span>Campo Obrigatório</span>
    </mat-error> -->
  </mat-form-field>
</div>
